
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as EliminationIcon } from "../fontello/icons/svg/ic_elimination.svg"


const Elimination = ({ ...props }) => (
  <SvgIcon
    component={EliminationIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Elimination
